import 'slick-carousel';

/**
 * Slider component
 */

const Slider = {
    // Default-Optionen für alle Slider
    defaults: {
        cssEase: 'ease-out',
        speed: 500,
        autoplaySpeed: 5000,
        prevArrow: '<a class="slick-prev"></a>',
        nextArrow: '<a class="slick-next"></a>',
    },
};

function recommendationListFixedHeight() {
    if (window.innerWidth > 576) {
        if (document.querySelectorAll('.mod_recommendationlist').length) {
            let elements = document.querySelectorAll('.mod_recommendationlist .slick-slide');
            let maxHeight = -1;

            for (const el of elements) {
                maxHeight = maxHeight > el.clientHeight ? maxHeight : el.clientHeight;
            }

            document.querySelector('.mod_recommendationlist .slick-track').style.height = maxHeight + 'px';
        }
    }
}

function createControlWrapper(insideNode) {
    let controlWrapper = document.createElement('div');
    controlWrapper.className = 'slick-controls';
    // let insideNodes = document.getElementsByClassName(insideNodesClassName);

    if (insideNode.parentNode) insideNode.parentNode.prepend(controlWrapper);

    let prevLink = document.createElement('a');
    prevLink.className = 'slick-prev';
    let nextLink = document.createElement('a');
    nextLink.className = 'slick-next';
    controlWrapper.append(prevLink);
    controlWrapper.append(nextLink);

    return controlWrapper;
}

function initSliders() {
    // Elemente wrappen, wenn der ganze Artikel ein Slider ist
    $('.mod_article.slider').each(function () {
        $(this).find('.content_wrapper > div').wrapAll('<div class="ce_slider"/><div class="ce_slider_inside"/>');
    });

    /**
     * Sliders
     */
    $('.ce_slider_inside, .content-gallery.slider .list').each(function () {
        let slickControls = createControlWrapper(this);
        $(this).slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            cssEase: Slider.defaults.cssEase,
            speed: Slider.defaults.speed,
            autoplaySpeed: Slider.defaults.autoplaySpeed,
            autoplay: !$(this).parents('.no-autoplay').length > 0,
            dots: !$(this).parents('.no-dots').length > 0,
            arrows: !$(this).parents('.no-arrows').length > 0,
            fade: true,
            prevArrow: slickControls.querySelector('.slick-prev'),
            nextArrow: slickControls.querySelector('.slick-next'),
        });
    });
}

function initCarousels() {
    $('.mod_article.carousel').each(function () {
        $(this).find('.content_wrapper > div').wrapAll('<div class="ce_carousel"/><div class="ce_carousel_inside"/>');
    });

    // createControlWrapper('ce_carousel');
    // createControlWrapper('ce_page_teasers');
    // createControlWrapper('mod_recommendationlist');

    /**
     * Carousels
     */
    $(
        '.ce_carousel_inside, .content-gallery.carousel .list, .ce_page_teasers .ce_inside, .mod_recommendationlist > .ce_inside'
    ).each(function () {
        let slickControls = createControlWrapper(this);

        $(this).slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            cssEase: Slider.defaults.cssEase,
            speed: Slider.defaults.speed,
            autoplaySpeed: Slider.defaults.autoplaySpeed,
            arrows: !$(this).parents('.no-arrows').length > 0,
            autoplay: false,
            dots: !$(this).parents('.no-dots').length > 0,
            infinite: false,
            prevArrow: slickControls.querySelector('.slick-prev'),
            nextArrow: slickControls.querySelector('.slick-next'),
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 2,
                    },
                },
                {
                    breakpoint: 576,
                    settings: {
                        slidesToShow: 1,
                    },
                },
            ],
        });
    });
}

document.addEventListener('DOMContentLoaded', function () {
    initSliders();
    initCarousels();
    recommendationListFixedHeight();
});
